import Axios from '@/plugins/axios'
// 获取设备异常字典
export function getDeviceAbnormalDict() {
    return Axios({
        url: `/user-system/alarm-type-list`,
        method: 'get'
    })
}

// 获取工单状态字典
export function getWorkOrderStatusDict() {
    return Axios({
        url: `/user-system/record-type-list`,
        method: 'get'
    })
}

// 查询硬件报警统计日报
export function getHardwareAlarmStatisticsDaily(params) {
    return Axios({
        url: `/user-system/page-list`,
        method: 'post',
        data: params
    })
}

// 日报表记录编辑
export function editHardwareAlarmStatisticsDaily(params) {
    return Axios({
        url: `/user-system/edit-record`,
        method: 'post',
        data: params
    })
}

// 获取硬件列表
export function getHardwareList() {
    return Axios({
        url: `/user-system/module-list`,
        method: 'get'
    })
}

// 获取项目硬件月报列表
export function getProjectMonthlyReportList(params) {
    return Axios({
        url: `/user-system/page-list-by-project`,
        method: 'post',
        data: params
    })
}

// 获取项目硬件月报列表
export function getMonthlyReport(params) {
    return Axios({
        url: `/user-system/page-list-by-device`,
        method: 'post',
        data: params
    })
}

// 导出硬件日报表
export function exportHardwareDailyReport(params) {
    return Axios({
        url: `/user-system/export-record`,
        method: 'post',
        data: params
    })
}

// 导出项目硬件月报
export function exportProjectMonthlyReport(params) {
    return Axios({
        url: `/user-system/export-by-company`,
        method: 'post',
        data: params
    })
}

// 导出硬件月报
export function exportMonthlyReport(params) {
    return Axios({
        url: `/user-system/export-by-device`,
        method: 'post',
        data: params
    })
}

// 切换是否虚拟设备
export function changeVirtualDevice(params) {
    return Axios({
        url: `/user-system/change-device-status`,
        method: 'post',
        data: params
    })
}

// 根据id获取硬件报表详情
export function getHardwareReportDetail(params) {
    return Axios({
        url: `/user-system/hardware-detail/${params.id}`,
        method: 'get'
    })
}

